let selectElements = Array.from(document.querySelectorAll('.dropdown-select'));
let insoleElementsOne = Array.from(document.querySelectorAll("[data-option='1']"));
let insoleElementsTwo = Array.from(document.querySelectorAll("[data-option='2']"));

let selectChangeHandler = (chosenValue, option) => {
	option === '1' ? (colElements = insoleElementsOne) : (colElements = insoleElementsTwo);
	colElements.forEach((element) => {
		element.style.display = 'none';
	});

	let elements = Array.from(
		document.querySelectorAll(`[data-insole="${chosenValue.target.value}"][data-option="${option}"]`)
	);
	elements.forEach((element) => {
		element.style.display = 'block';
	});
};

selectElements.forEach((element) => {
	element.addEventListener('change', () => selectChangeHandler(event, element.dataset.col));
});
